import type { Trade, TradeCurrentLocation } from '@/models/types';
import TradeCurrentLocationEditor from './trade-current-location-editor';
import TradeEverLocationEditor from './trade-ever-location-editor';
import TradePostalCodeEditor from './trade-postal-editor';
import TradeStateEditor from './trade-state-editor';

// "ever_location": null,
// "state": "CA",
// "postal_code": "94577",

const TradeVehicleEditor = ({
  tradeId,
  currentLocation,
  everLocation,
  state,
  postalCode,
}: {
  tradeId: Trade['id'];
  currentLocation: TradeCurrentLocation;
  everLocation: string;
  state: string;
  postalCode: string;
}) => {
  return (
    <div className="flex flex-col gap-1 dark:bg-dark dark:text-white">
      <div className="flex flex-col w-full gap-1 justify-between flex-wrap">
        <TradeCurrentLocationEditor
          tradeId={tradeId}
          currentLocation={currentLocation}
        />

        <TradeEverLocationEditor
          tradeId={tradeId}
          initialEverLocation={everLocation}
        />

        <TradeStateEditor tradeId={tradeId} initialState={state} />

        <TradePostalCodeEditor
          tradeId={tradeId}
          initialPostalCode={postalCode}
        />
      </div>
    </div>
  );
};

export default TradeVehicleEditor;
